import { BottomNavbarCenterMenu, BottomNavbarRightMenu } from "../../Navbar/BottomNavBarMenu";
import { ICON } from "../../Icons/Icons";
import { CHAT_EVENTS } from "../../../constants/chat";
import { types } from "../../Chat/ChatPanelTitle";
import { CHAT_NOTIFICATION } from "../../Chat/ChatNotifications";
import { WEBRTC_EVENTS } from "../../../constants/webrtc";
import { SCENE_INTERACTION } from "../../../constants/scene";
import { isFullscreen, toggleFullscreen } from "../../engine/helpers/worldHelpers";
import { CALL_VIEW } from "../constants";

export class CallChatControls extends BottomNavbarRightMenu {
  static selector() {
    return $('#one-on-one__right-control')
  }

  static template() {
    return `
<section
  id="one-on-one__right-control"
  class="world-bottom-nav__area world-bottom-nav__right_area"
  style="display: none;"
>
  <div class="world-bottom-nav__area__item one-on-one__controls__chat">
    ${ICON.CHAT}
    <div class="world-bottom-nav__area__chat__badge" style="display: none;"></div>
  </div>
</section>
`;
  }

  /**
   * @param OneOnOneController controller
   * @param Model model
   */
  static init({ controller, model }) {
    this.controller = controller
    this.model = model

    const $container = $('#oneOnOneVideoContainer')
    const $badge = $container.find('.world-bottom-nav__area__chat__badge')
    const $chatToggle = $('.one-on-one__controls__chat');

    let chatPanel = null

    const openChatPanel = () => {
      const targetUserId = controller.peerInfo.userId
      console.log('targetUserId', targetUserId)
      if (!targetUserId) {
        return
      }

      const $chatPanelBackButton = $(`#${targetUserId}.chat-container .back-button`)

      this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_ONE_ON_ONE, data: { id: targetUserId, type: types.PRIVATE } })
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
      $chatPanelBackButton.hide();

      if (!chatPanel) {
        chatPanel = this.model.chatPanel?.privateChats?.[targetUserId]

        if (chatPanel) {
          chatPanel.addEventListener('closed', () => {
            $container.removeClass('on-chat-open')
            $chatToggle.removeClass('selected')
            $chatPanelBackButton.show();
          })
        }
      }
    }

    $chatToggle.on('click', () => {
      const targetUserId = controller.peerInfo?.userId;
      if (!targetUserId) {
        return
      }

      const $chatPanel = $(`#${targetUserId}.chat-container`)

      if ($chatPanel.is(':visible')) {
        this.model.chatPanel.closeAllChats()
      } else {
        openChatPanel()
      }
    })

    this.model.chatPanel?.chatNotifications?.addEventListener(CHAT_NOTIFICATION.CHANGED, (e) => {
      const { data } = e;

      const targetUserId = controller.peerInfo?.userId;
      if (!targetUserId || !data?.PRIVATE?.[targetUserId]) {
        return
      }

      const numOfUnreadMessage = data.PRIVATE[targetUserId] ?? 0

      if (numOfUnreadMessage > 0) {
        $badge.text(numOfUnreadMessage)
        $badge.show()
      } else {
        $badge.hide()
      }
    })
  }
}

export class CallScreenSharingButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item one-on-one__controls__share-screen">
  ${ICON.SHARE_SCREEN}
</div>
    `
  }

  /**
   * @param OneOnOneController controller
   */
  static init({ controller }) {
    const $shareScreenButton = $('.one-on-one__controls__share-screen');

    $shareScreenButton.on('click', () => {
      if ($shareScreenButton.hasClass('selected')) {
        controller.stopScreenSharing();
      } else {
        controller.startScreenSharing();
      }
    });
  }

  static toggleSelected(isSelected) {
    const $shareScreenButton = $('.one-on-one__controls__share-screen');
    if (isSelected) {
      $shareScreenButton.addClass('selected');
    } else {
      $shareScreenButton.removeClass('selected');
    }
  }
}

export class CallMicControlButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item one-on-one__controls__mic one-on-one__controls__mic--mute">
  ${ICON.MIC_ON}
</div>
<div class="world-bottom-nav__area__item one-on-one__controls__mic one-on-one__controls__mic--unmute" style="display: none;">
  ${ICON.MIC_OFF}
</div>
    `
  }

  /**
   * @param OneOnOneController controller
   */
  static init({ controller }) {
    const $muteButton = $('.one-on-one__controls__mic--mute');
    const $unmuteButton = $('.one-on-one__controls__mic--unmute');

    $muteButton.on('click', () => {
      controller.muteLocalMic()

      $muteButton.hide()
      $unmuteButton.show()
    })

    $unmuteButton.on('click', () => {
      controller.unmuteLocalMic()

      $muteButton.show()
      $unmuteButton.hide()
    })
  }
}

export class CallCameraControlButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item one-on-one__controls__camera one-on-one__controls__camera--mute">
  ${ICON.CAMERA_ON}
</div>
<div class="world-bottom-nav__area__item one-on-one__controls__camera one-on-one__controls__camera--unmute" style="display: none;">
  ${ICON.CAMERA_OFF}
</div>
    `
  }

  /**
   * @param OneOnOneController controller
   */
  static init({ controller }) {
    const $muteButton = $('.one-on-one__controls__camera--mute');
    const $unmuteButton = $('.one-on-one__controls__camera--unmute');

    $muteButton.on('click', () => {
      controller.turnOffLocalCamera()
      this.updateParticipantMediaUI({ isCameraOff: true })
    })

    $unmuteButton.on('click', () => {
      controller.turnOnLocalCamera()
      this.updateParticipantMediaUI({ isCameraOff: false })
    })
  }

  static updateParticipantMediaUI({ isCameraOff }) {
    const $avatar = $("#own-avatar-call");
    const $muteButton = $('.one-on-one__controls__camera--mute');
    const $unmuteButton = $('.one-on-one__controls__camera--unmute');

    if (isCameraOff) {
      $muteButton.hide()
      $unmuteButton.show()
      $avatar.show()
    } else {
      $muteButton.show()
      $unmuteButton.hide()
      $avatar.hide()
    }
  }
}

export class CallMinimizeButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item one-on-one__controls__minimize" title="Minimize call">
  ${ICON.MINIMIZE}
</div>
<div class="world-bottom-nav__area__item one-on-one__controls__maximize" title="Maximize call" style="display: none;">
  ${ICON.EXPAND}
</div>
    `
  }

  static init({ controller }) {
    const $minimizeButton = $('.one-on-one__controls__minimize');
    const $maximizeButton = $('.one-on-one__controls__maximize');

    $minimizeButton.on('click', () => {
      controller.enterMinimizedView()
    })

    $maximizeButton.on('click', () => {
      controller.enterStandardView()
    })
  }

  static toggleMinimized(isMinimized) {
    const $minimizeButton = $('.one-on-one__controls__minimize');
    const $maximizeButton = $('.one-on-one__controls__maximize');

    if (isMinimized) {
      $minimizeButton.hide()
      $maximizeButton.show()
    } else {
      $maximizeButton.hide()
      $minimizeButton.show()
    }
  }
}

export class CallHangupButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item end-call-btn world-bottom-nav__area__item--danger">
  ${ICON.CALL_HANGUP}
</div>
    `
  }

  /**
   * @param OneOnOneController controller
   * @param Model model
   */
  static init({ controller, model }) {
    const $hangupButton = $('.end-call-btn');
    $hangupButton.on('click', () => {
      if (document.getElementById('peer-video-call')) {
        document.getElementById('peer-video-call').srcObject = null;
      }

      controller.hangUpCall(true, true);
      controller.leaveCall();

      const classToBeRemoved = `video_notification_from_${controller.myInfo.userId}`;
      model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, data: { classToBeRemoved } });
      model.hideLoading();
    })
  }
}

export class CallControls extends BottomNavbarCenterMenu {
  static selector() {
    return $('#one-on-one__center-control')
  }

  static template() {
    return `
<section
  id="one-on-one__center-control"
  class="world-bottom-nav__area world-bottom-nav__center_area one-on-one__controls"
>
  ${CallScreenSharingButton.template()}
  ${CallMicControlButton.template()}
  ${CallCameraControlButton.template()}
  ${CallMinimizeButton.template()}
  ${CallHangupButton.template()}
</section>
    `;
  }
}

export class CallContainer {
  static template() {
    return `
<div id="oneOnOneVideoContainer" class="one-on-one">
  <div class="one-on-one__wrapper">
    <section class="one-on-one__grid">
      <div
        id='my-own-video-wrapper-call'
        class="one-on-one__grid__item"
      >
        <div class="one-on-one__media">
          <img
            src='#'
            id='own-avatar-call'
            class='local-avatar one-on-one__media__avatar'
            onError='this.src = "textures/defaultAvatar.png"'
          />
          <video
            id='own-video-call'
            class='already-muted one-on-one__media__camera'
            autoplay playsinline muted
          ></video>
          <div
            class="one-on-one__media__audio-indicator"
            id="my-audio-indicator"
          >
            <span></span><span></span><span></span>
          </div>
          <div
            class="one-on-one__media__mute-indicator"
            style="display: none;"
          >
            ${ICON.MIC_OFF}
          </div>
        </div>
      </div>
      
      <div
        id='my-peer-video-wrapper-call'
        class="one-on-one__grid__item"
      >
        <div class="one-on-one__media">
          <img
            src='#'
            id='peer-avatar-call'
            class="one-on-one__media__avatar"
            data-id=''
            onError='this.src = "textures/defaultAvatar.png"'
          />
          <video
            id='peer-video-call'
            class='already-muted one-on-one__media__camera'
            autoplay playsinline
          ></video>
          <div
            id="peer-audio-indicator"
            class="one-on-one__media__audio-indicator"
          >
            <span></span><span></span><span></span>
          </div>
          <div
            class="one-on-one__media__mute-indicator"
            style="display: none;"
          >
            ${ICON.MIC_OFF}
          </div>
        </div>
      </div>
      
      <div
        id='one-on-one__screen-share-container'
        class="one-on-one__grid__item one-on-one__grid__item--screen-share"
        style="display: none;"
      >
        <div class="one-on-one__media one-on-one__media--screen-share">
          <video
            class='one-on-one__media__screen'
            autoplay 
            playsinline
            muted
          ></video>

          <div class="one-on-one__media__screen-controls">
            <div class="one-on-one__media__screen-controls__fullscreen" title="Enter fullscreen">
              ${ICON.MAKE_FULLSCREEN}
            </div>
            <div class="one-on-one__media__screen-controls__exit-fullscreen" title="Exit fullscreen" style="display: none;">
              ${ICON.EXIT_FULLSCREEN}
            </div>
          </div>
        </div>
      </div>
  
  
      <input type="hidden" id="one-on-one-video-call-peer-id">
      <input type="checkbox" id="peer-radial-actions">
      <!--<div id="peer-actions-holder">
        <div class='action' id="video-call-chat">
          <span class='material-icons'>forum</span>
        </div>
        <div class='action' id="video-call-info">
          <span class='material-icons'>person</span>
        </div>
        <div class='action' id="video-call-jump">
          <span class='material-icons'>location_pin</span>
        </div>
      </div>-->
    </section>
  </div>
</div>
`;
  }

  /**
   * @param OneOnOneController controller
   * @param Model model
   */
  init({ controller, model }) {
    this.controller = controller
    this.model = model

    this.addEventListeners()
    this.setupScreenShareControls()
  }

  setupScreenShareControls() {
    const $fullscreenButton = $('.one-on-one__media__screen-controls__fullscreen');
    const $exitFullscreenButton = $('.one-on-one__media__screen-controls__exit-fullscreen');

    $fullscreenButton.on('click', () => {
      this.toggleScreenShareFullscreen();
      $fullscreenButton.hide();
      $exitFullscreenButton.show();
    });

    $exitFullscreenButton.on('click', () => {
      this.toggleScreenShareFullscreen();
      $exitFullscreenButton.hide();
      $fullscreenButton.show();
    });

    // Listen for fullscreen change events using jQuery
    $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange',
      this.handleFullscreenChange.bind(this)
    );
  }

  handleFullscreenChange() {
    const $fullscreenButton = $('.one-on-one__media__screen-controls__fullscreen');
    const $exitFullscreenButton = $('.one-on-one__media__screen-controls__exit-fullscreen');

    // Check fullscreen state using jQuery
    const isFullscreen = document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (isFullscreen) {
      $fullscreenButton.hide();
      $exitFullscreenButton.show();
    } else {
      $exitFullscreenButton.hide();
      $fullscreenButton.show();
    }
  }

  addEventListeners() {
    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
      if (!this.model.activeOneOnOneCall) {
        return
      }

      const { data } = e

      this.updateParticipantMediaUI({
        isMe: String(data.userId) === String(this.model.config.userId),
        userAudioMuted: data.userAudioMuted,
        userVideoMuted: data.userVideoMuted
      })
    })
  }

  updateParticipantInfo({ participantBlockId, avatarUrl, id }) {
    const $participantBlock = $(`#${participantBlockId}`)
    const $avatar = $participantBlock.find('.one-on-one__media__avatar')

    $avatar.attr('src', avatarUrl)
    $avatar.attr('data-id', `avatar_${id}`)
  }

  displayCallOverlay() {
    this.updateParticipantInfo({
      participantBlockId: 'my-own-video-wrapper-call',
      avatarUrl: this.controller.myInfo.userAvatarUrl,
      id: this.controller.myInfo.userId
    })

    if (this.controller.peerInfo) {
      this.updateParticipantInfo({
        participantBlockId: 'my-peer-video-wrapper-call',
        avatarUrl: this.controller.peerInfo.userAvatarUrl,
        id: this.controller.peerInfo.userId,
      })

      $("#one-on-one-video-call-peer-id").val(`${this.controller.peerInfo.userId}`);
    }

    $("#oneOnOneVideoContainer").addClass('active');

    CallControls.show()
    CallChatControls.show()
  }

  updateParticipantMediaUI({ isMe, userAudioMuted, userVideoMuted }) {
    const $wrapper = isMe ? $('#my-own-video-wrapper-call') : $('#my-peer-video-wrapper-call')
    const $audioIndicator = $wrapper.find('.one-on-one__media__audio-indicator')
    const $video = $wrapper.find('video')
    const $avatar = $wrapper.find('img')
    const $muteIndicator = $wrapper.find('.one-on-one__media__mute-indicator')

    if (userAudioMuted) {
      $audioIndicator.hide()
      $muteIndicator.show()
    } else {
      $audioIndicator.show()
      $muteIndicator.hide()
    }

    if (userVideoMuted) {
      $video.hide()
      $avatar.show()
    } else {
      $video.show()
      $avatar.hide()
    }
  }

  toggleScreenShareUI(isSharing) {
    if (isSharing) {
      this.applyCallView(CALL_VIEW.SCREENSHARE)
    } else {
      this.applyCallView(CALL_VIEW.STANDARD)
    }
  }

  applyCallView(view) {
    const $body = $('body')
    const $wrapper = $('#oneOnOneVideoContainer')
    const $shareScreenContainer = $('#one-on-one__screen-share-container')

    $wrapper.removeClass('call-minimized screen-sharing-active')
    $body.removeClass('call-minimized screen-sharing-active')

    if (view === CALL_VIEW.SCREENSHARE) {
      $shareScreenContainer.show()
      $wrapper.addClass('screen-sharing-active')
      $body.addClass('screen-sharing-active')
      return
    }

    $shareScreenContainer.hide()

    if (view === CALL_VIEW.MINIMIZED) {
      $wrapper.addClass('call-minimized')
      $body.addClass('call-minimized')
    }
  }

  #setVideoStream($selector, stream, configs = {}) {
    const videoElement = $selector.get(0)

    if (videoElement) {
      videoElement.srcObject = stream

      if (configs?.preprocess) {
        configs.preprocess(videoElement)
      }

      if (configs?.callback) {
        configs.callback(videoElement)
      }
    }

    return $selector
  }

  setOwnVideoStream(stream, configs = {}) {
    const $ownVideo = $('#own-video-call')

    return this.#setVideoStream($ownVideo, stream, configs)
  }

  setPeerVideoStream(stream, configs = {}) {
    const $peerVideo = $('#peer-video-call')

    return this.#setVideoStream($peerVideo, stream, configs)
  }

  setShareVideoStream(stream, configs = {}) {
    const $shareScreenContainer = $('#one-on-one__screen-share-container')
    const $shareScreenVideo = $shareScreenContainer.find('video')

    return this.#setVideoStream($shareScreenVideo, stream, configs)
  }

  /**
   * Toggles fullscreen mode for the screen sharing video element
   * @returns {Promise<void>} A promise that resolves when the fullscreen action completes
   */
  async toggleScreenShareFullscreen() {
    try {
      // Get the screen share container element instead of just the video
      const screenShareContainer = document.getElementById('one-on-one__screen-share-container');

      if (!screenShareContainer) {
        console.error('Screen share container element not found');
        return;
      }

      // Use the toggleFullscreen helper function on the container
      await toggleFullscreen(screenShareContainer);

      this._handleFullscreenChange();
    } catch (error) {
      console.error('Error toggling fullscreen mode:', error);
    }
  }

  /**
   * Handles fullscreen change events
   * @private
   */
  _handleFullscreenChange = () => {
    const $fullscreenButton = $('.one-on-one__media__screen-controls__fullscreen');
    const $exitFullscreenButton = $('.one-on-one__media__screen-controls__exit-fullscreen');

    if (isFullscreen()) {
      $fullscreenButton.hide();
      $exitFullscreenButton.show();
    } else {
      $exitFullscreenButton.hide();
      $fullscreenButton.show();
    }
  }
}
